<template>
  <div
    id="detailsform"
    class="
      shadow-xl
      rounded-md
      m-5
      lg:border-2 lg:border-blue-600 lg:pb-1 lg:p-5 lg:ml-6
      md:w-full
      relative
    "
  >
    <!-- tab titles -->
    <div
      id="formtitle"
      class="
        border-2
        w-full
        flex
        justify-center
        items-center
        bg-blue-600
        text-blue-200
      "
    >
      <div class="text-sm breadcrumbs">
        <ul>
          <li>
            <a>Application</a>
          </li>
          <li>
            <a>Userdetails</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- tab titles -->

    <loader v-if="saveDataLoader" />
    <vee-form
      :validation-schema="schema"
      id="userdetails"
      class="
        lg:h-auto
        w-full
        flex flex-col
        items-center
        justify-center
        px-5
        py-4
        mx-3
        lg:grid lg:grid-flow-row lg:grid-cols-4 lg:gap-2
      "
      @submit="userInfo"
    >
      <!-- userinfos -->
      <div class="form-control w-full">
        <label for="name" class="label">
          <span class="label-text">Full Name</span></label
        >
        <vee-field
          name="Candidate_name"
          v-model="Candidate_name"
          type="text"
          id="name"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Candidate_name" />
      </div>
      <div class="form-control w-full">
        <label for="fhname" class="label">
          <span class="label-text">Father's / Husband's Name</span></label
        >
        <vee-field
          name="Father_Husband_Name"
          v-model="Father_Husband_Name"
          type="text"
          id="fhname"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Father_Husband_Name" />
      </div>
      <div class="form-control w-full">
        <label for="dob" class="label">
          <span class="label-text">Date of Birth</span></label
        >
        <vee-field
          name="DOB"
          v-model="DOB"
          type="date"
          id="dob"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="DOB" />
      </div>
      <div class="form-control w-full">
        <label for="mobno" class="label">
          <span class="label-text">Mobile.no</span></label
        >
        <vee-field
          name="Candidate_mobileno"
          v-model="Candidate_mobileno"
          type="number"
          id="mobno"
          class="input input-bordered"
        />
        <ErrorMessage class="text-red-600" name="Candidate_mobileno" />
      </div>
      <!-- userinfos -->

      <!-- address -->
      <div
        class="
          border-2 border-blue-500
          grid grid-flow-col
          gap-1
          p-4
          grid-rows-3
          col-span-2
        "
      >
        <div class="form-control w-full">
          <label for="Present_Address1" class="label">
            <span class="label-text">Present Address</span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Present_Address1"
              v-model="Present_Address1"
              type="text"
              id="Present_Address1"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Present_Address1" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="Present_Address2" class="label">
            <span class="label-text">Present Address 2</span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Present_Address2"
              v-model="Present_Address2"
              type="text"
              id="Present_Address2"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Present_Address2" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="Present_Address3" class="label">
            <span class="label-text">Present Address 3</span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Present_Address3"
              v-model="Present_Address3"
              type="text"
              id="Present_Address3"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Present_Address3" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="pincode" class="label">
            <span class="label-text">Pincode</span></label
          >
          <vee-field
            name="Present_pincode"
            v-model="Present_pincode"
            @change="pincodeapi"
            type="number"
            id="pincode"
            class="input input-bordered"
          />
          <label class="label">
            <p class="label-text-alt text-black">
              <span>💡</span> City and State wil be automaticall updated
            </p>
          </label>
          <ErrorMessage class="text-red-600" name="Present_pincode" />
        </div>
        <div class="form-control w-full">
          <label for="city" class="label">
            <span class="label-text">City</span></label
          >
          <vee-field
            name="Present_City"
            v-model="Present_City"
            type="text"
            disabled="disabled"
            id="city"
            class="input input-bordered"
          />
          <ErrorMessage class="text-red-600" name="Present_City" />
        </div>
        <div class="form-control w-full">
          <label for="state" class="label">
            <span class="label-text">State</span></label
          >
          <vee-field
            name="Present_State"
            v-model="Present_State"
            type="text"
            disabled="disabled"
            id="state"
            class="input input-bordered"
          />
          <ErrorMessage class="text-red-600" name="Present_State" />
        </div>
      </div>
      <!-- present -->
      <!-- permanent -->
      <div
        class="
          border-2 border-blue-500
          grid
          gap-2
          grid-flow-col
          p-4
          grid-rows-3
          col-span-2
        "
      >
        <div class="form-control w-full">
          <label for="Permanent_Address1" class="label">
            <span class="label-text">Permanent Address </span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Permanent_Address1"
              v-model="Permanent_Address1"
              type="text"
              id="Permanent_Address1"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Permanent_Address1" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="Permanent_Address2" class="label">
            <span class="label-text">Permanent Address 2</span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Permanent_Address2"
              v-model="Permanent_Address2"
              type="text"
              id="Permanent_Address2"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Permanent_Address2" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="Permanent_Address3" class="label">
            <span class="label-text">Permanent Address 3</span></label
          >
          <div class="relative">
            <span class="absolute right-3 bottom-3 top-3"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
                /></svg
            ></span>
            <vee-field
              name="Permanent_Address3"
              v-model="Permanent_Address3"
              type="text"
              id="Permanent_Address3"
              class="input input-bordered w-full"
            />
            <ErrorMessage class="text-red-600" name="Permanent_Address3" />
          </div>
        </div>
        <div class="form-control w-full">
          <label for="Permanent_pincode" class="label">
            <span class="label-text">Pincode</span></label
          >
          <vee-field
            name="Permanent_pincode"
            v-model="Permanent_pincode"
            @change="permanent_pincodeapi"
            type="number"
            id="Permanent_pincode"
            class="input input-bordered"
          />
          <label class="label">
            <p class="label-text-alt text-black">
              <span>💡</span> City and State wil be automaticall updated
            </p>
          </label>
          <ErrorMessage class="text-red-600" name="Permanent_pincode" />
        </div>
        <div class="form-control w-full">
          <label for="Permanent_City" class="label">
            <span class="label-text">City</span></label
          >
          <vee-field
            name="Permanent_City"
            v-model="Permanent_City"
            type="text"
            disabled="disabled"
            id="Permanent_City"
            class="input input-bordered"
          />
          <ErrorMessage class="text-red-600" name="Permanent_City" />
        </div>
        <div class="form-control w-full">
          <label for="Permanent_State" class="label">
            <span class="label-text">State</span></label
          >
          <vee-field
            name="Permanent_State"
            v-model="Permanent_State"
            type="text"
            disabled="disabled"
            id="Permanent_State"
            class="input input-bordered"
          />
          <ErrorMessage class="text-red-600" name="Permanent_State" />
        </div>
      </div>
      <!-- permanent -->
      <!-- address -->
      <div class="form-control w-full">
        <label class="cursor-pointer label" @click="sameaddress">
          <input type="checkbox" class="checkbox" v-model="sameAddress" />
          <span class="label-text lg:ml-2 text-sm"
            >Is your Present address same as Permanent address

            <!-- <span class="label-text-alt">if yes click the checkbox</span> -->
          </span>
        </label>
      </div>
      <!-- Marital status -->
      <div class="form-control w-full">
        <label class="cursor-pointer label">
          <span class="label-text text-sm">Marital Status</span>
          <label for="Married" class="label">
            <span class="label-text font-semibold">Married</span></label
          >
          <vee-field
            name="Marital_status"
            v-model="Marital_status"
            type="radio"
            id="Married"
            value="Married"
            class="radio"
          />
          <label for="Unmarried" class="label">
            <span class="label-text font-semibold">Unmarried</span></label
          >
          <vee-field
            name="Marital_status"
            v-model="Marital_status"
            type="radio"
            value="Unmarried"
            id="Unmarried"
            class="radio"
          />
        </label>
      </div>
      <!-- Marital status -->

      <!-- <br> -->
      <div id="button" class="from-control w-full">
        <button
          type="submit"
          class="btn btn-info hover:bg-blue-500 lg:w-1/3 w-full mx-4 my-3"
        >
          <span v-if="status"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fill-rule="evenodd"
                d="M6.267 3.455a3.066 3.066 0 001.745-.723 3.066 3.066 0 013.976 0 3.066 3.066 0 001.745.723 3.066 3.066 0 012.812 2.812c.051.643.304 1.254.723 1.745a3.066 3.066 0 010 3.976 3.066 3.066 0 00-.723 1.745 3.066 3.066 0 01-2.812 2.812 3.066 3.066 0 00-1.745.723 3.066 3.066 0 01-3.976 0 3.066 3.066 0 00-1.745-.723 3.066 3.066 0 01-2.812-2.812 3.066 3.066 0 00-.723-1.745 3.066 3.066 0 010-3.976 3.066 3.066 0 00.723-1.745 3.066 3.066 0 012.812-2.812zm7.44 5.252a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clip-rule="evenodd"
              /></svg
          ></span>
          <span v-else>Save</span>
        </button>
      </div>
    </vee-form>
    <div>
      <div v-if="response" class="alert alert-info absolute bottom-5 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3 7v10a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-6l-2-2H5a2 2 0 00-2 2z"
            ></path>
          </svg>
          <label
            >Your data has been saved click next to fill more details</label
          >
        </div>
      </div>
      <div v-if="error" class="alert alert-error absolute bottom-5 right-3">
        <div class="flex-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            class="w-6 h-6 mx-2 stroke-current"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636"
            ></path>
          </svg>
          <label
            >Your data is not saved please try again later or call sitra
            customer serive
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import loader from "../../loader.vue";
export default {
  name: "User Details",
  components: { loader },
  data() {
    return {
      status: false,
      sameAddress: null,
      saveDataLoader: false,
      response: false,
      error: false,
      schema: {
        Candidate_name: "required|alpha_spaces",
        Father_Husband_Name: "required|alpha_spaces",
        DOB: "required",
        Present_Address1: "required",
        Present_pincode: "min:6|max:6",
        Present_City: "required|alpha_spaces",
        Present_State: "required|alpha_spaces",
        Permanent_Address1: "required",
        Permanent_pincode: "min:6|max:6",
        Permanent_City: "required|alpha_spaces",
        Permanent_State: "required|alpha_spaces",
        Candidate_mobileno: "min:10|max:10",
      },
    };
  },
  created() {
    this.getUserinfo();
  },
  updated() {
    this.deleteinfo();
  },
  computed: {
    Candidate_name: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Candidate_name;
      },
      set(value) {
        this.$store.dispatch("Candidate/updateName", value);
      },
    },
    Father_Husband_Name: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Father_Husband_Name;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatefhname", value);
      },
    },
    DOB: {
      get() {
        return this.$store.state.Candidate.application.userinfo.DOB;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatedob", value);
      },
    },
    Present_Address1: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Present_Address1;
      },
      set(value) {
        this.$store.dispatch("Candidate/updateaddress1", value);
      },
    },
    Present_Address2: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Present_Address2;
      },
      set(value) {
        this.$store.dispatch("Candidate/updateaddress2", value);
      },
    },
    Present_Address3: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Present_Address3;
      },
      set(value) {
        this.$store.dispatch("Candidate/updateaddress3", value);
      },
    },
    Present_pincode: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Present_pincode;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatepincode", value);
      },
    },
    Present_City: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Present_City;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatecity", value);
      },
    },
    Present_State: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Present_State;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatestates", value);
      },
    },
    Permanent_Address1: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Permanent_Address1;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatePaddress1", value);
      },
    },
    Permanent_Address2: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Permanent_Address2;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatePaddress2", value);
      },
    },
    Permanent_Address3: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Permanent_Address3;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatePaddress3", value);
      },
    },
    Permanent_pincode: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Permanent_pincode;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatepincode2", value);
      },
    },
    Permanent_City: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Permanent_City;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatecity2", value);
      },
    },
    Permanent_State: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Permanent_State;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatestates2", value);
      },
    },
    Candidate_mobileno: {
      get() {
        return this.$store.state.Candidate.application.userinfo
          .Candidate_mobileno;
      },
      set(value) {
        this.$store.dispatch("Candidate/updatemobno", value);
      },
    },
    Marital_status: {
      get() {
        return this.$store.state.Candidate.application.userinfo.Marital_status;
      },
      set(value) {
        this.$store.dispatch("Candidate/updateMaritalstatus", value);
      },
    },
  },
  methods: {
    userInfo(values) {
      confirm("Are you sure you filled the form with correct data?");
      values.Reg_id = this.$store.state.Candidate.application.Id;
      const jsondata = JSON.stringify(values);
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/InsertApplication`,
          jsondata
        )
        .then((res) => {
          if (res.status == 200) {
            this.status = true;
            this.response = true;
          }
          this.getUserinfo();
        })
        .catch((err) => {
          this.status = false;
          this.error = false;
          alert(
            "There is an error in our end, sorry for the inconvenience please try again later",
            err
          );
        });
    },
    getUserinfo() {
      axios
        .post(
          ` https://evening-coast-89083.herokuapp.com/http://sitraonline.org.in/employementhubapi/index.php/api/SelectApplication`,
          {
            Reg_id: sessionStorage.getItem("id"),
          }
        )
        .then((res) => {
          if (res.data.length == 0) {
            this.Candidate_name = "";
            this.Father_Husband_Name = "";
            this.Candidate_mobileno = "";
            this.DOB = "";
            this.Present_Address1 = "";
            this.Present_Address2 = "";
            this.Present_Address3 = "";
            this.Present_pincode = "";
            this.Present_City = "";
            this.Present_State = "";
            this.Permanent_Address1 = "";
            this.Permanent_Address2 = "";
            this.Permanent_Address3 = "";
            this.Permanent_pincode = "";
            this.Permanent_City = "";
            this.Permanent_State = "";
            this.Marital_status = "";
          } else if (res.data.length > 0) {
            this.Candidate_name = res.data[0].Candidate_name;
            this.Father_Husband_Name = res.data[0].Father_Husband_Name;
            this.DOB = res.data[0].DOB;
            this.Present_Address1 = res.data[0].Present_Address1;
            this.Present_Address2 = res.data[0].Present_Address2;
            this.Present_Address3 = res.data[0].Present_Address3;
            this.Present_pincode = res.data[0].Present_pincode;
            this.Present_City = res.data[0].Present_City;
            this.Present_State = res.data[0].Present_State;
            this.Permanent_Address1 = res.data[0].Permanent_Address1;
            this.Permanent_Address2 = res.data[0].Permanent_Address2;
            this.Permanent_Address3 = res.data[0].Permanent_Address3;
            this.Permanent_pincode = res.data[0].Permanent_pincode;
            this.Permanent_City = res.data[0].Permanent_City;
            this.Permanent_State = res.data[0].Permanent_State;
            this.Candidate_mobileno = res.data[0].Candidate_mobileno;
            this.Marital_status = res.data[0].Marital_status;
          }
        })
        .catch((err) => console.log(err));
    },
    deleteinfo() {
      this.Candidate_name = "";
      this.Father_Husband_Name = "";
      this.DOB = "";
      this.Present_Address1 = "";
      this.Present_Address2 = "";
      this.Present_Address3 = "";
      this.Present_pincode = "";
      this.Present_City = "";
      this.Present_State = "";
      this.Permanent_Address1 = "";
      this.Permanent_Address2 = "";
      this.Permanent_Address3 = "";
      this.Permanent_pincode = "";
      this.Permanent_City = "";
      this.Permanent_State = "";
      this.Candidate_mobileno = "";
      this.Marital_status = "";
    },
    pincodeapi() {
      axios
        .get(`https://api.postalpincode.in/pincode/${this.Present_pincode}`)
        .then((res) => {
          this.Present_State = res.data[0].PostOffice[0].State;
          this.Present_City = res.data[0].PostOffice[0].District;
        })
        .catch((err) => console.log(err.message));
    },
    permanent_pincodeapi() {
      axios
        .get(`https://api.postalpincode.in/pincode/${this.Permanent_pincode}`)
        .then((res) => {
          this.Permanent_State = res.data[0].PostOffice[0].State;
          this.Permanent_City = res.data[0].PostOffice[0].District;
        })
        .catch((err) => console.log(err.message));
    },
    sameaddress() {
      this.Permanent_Address1 = this.Present_Address1;
      this.Permanent_Address2 = this.Present_Address2;
      this.Permanent_Address3 = this.Present_Address3;
      this.Permanent_pincode = this.Present_pincode;
      this.Permanent_City = this.Present_City;
      this.Permanent_State = this.Present_State;
    },
  },
};
</script>
